import { useEffect, useState } from 'react';
import { authService } from '../services/authService';
import { realName } from '../utils/accountName';

/**
 * Имя, которым подпишется бот на встрече. Бот берёт его из профиля, а там оно
 * чаще пусто или равно почте — тогда в списке участников только «Бит.Ньютон»,
 * и никто не знает, чей это бот (прогон организаций 24.09, Р14). Форма «Позвать
 * бота» спрашивает имя, если его нет, и сохраняет в профиль. «Нет» — по общему
 * правилу utils/accountName.js: пусто, почта или её часть до @ (логин Keycloak).
 *
 * open — открыта ли форма: профиль спрашиваем, только когда он нужен.
 */
export function useBotName(open) {
  const [needsName, setNeedsName] = useState(false);
  const [name, setName] = useState('');
  // Имя из профиля — тоже едет в теле /join: bit-meetbot держит профиль из
  // проверки токена пять минут, и имя, сохранённое минуту назад, он ещё не знает.
  const [profileName, setProfileName] = useState(null);
  // Почта — чтобы и введённое сверить тем же правилом: логин вместо имени не
  // сохраняем, иначе форма спрашивала бы при каждом открытии.
  const [email, setEmail] = useState('');

  useEffect(() => {
    if (!open) return undefined;
    let alive = true;
    authService.getProfile()
      .then((p) => {
        // То же правило, что у кнопки меню: логин и почта именем не считаются.
        const current = realName(p?.email, p?.display_name);
        if (!alive) return;
        setEmail(p?.email || '');
        setNeedsName(!current);
        setProfileName(current);
      })
      // Профиль не прочитался — не мешаем звать бота лишним полем.
      .catch(() => { if (alive) setNeedsName(false); });
    return () => { alive = false; };
  }, [open]);

  /**
   * Перед отправкой бота: введённое имя уходит в профиль и возвращается для
   * тела /join; без ввода — имя из профиля. Профиль не сохранился — имя всё
   * равно едет с ботом.
   */
  const commit = async () => {
    // Ввели логин или почту — это не имя: не сохраняем, бот идёт без подписи.
    const value = realName(email, name);
    if (!needsName || !value) return profileName;
    try {
      await authService.updateDisplayName(value);
      setNeedsName(false);
      setProfileName(value);
    } catch (_) { /* подпись бота важнее сохранения в профиль */ }
    return value;
  };

  return { needsName, name, setName, commit };
}
